import React, { useEffect, useReducer, createContext } from "react";

import { useQuery } from "@apollo/client";
import { setPaymentCurrencies } from "../actions";
import { GET_PAYMENT_CURRENCIES } from "../../apollo/queries";

import paymentCurrenciesReducer from "../reducers/payment-currencies-reducer";

export const PaymentCurrenciesContext = createContext();
const PaymentCurrenciesProvider = PaymentCurrenciesContext.Provider;

export function PaymentCurrenciesWrapper({ children }) {
  const defaultPaymentCurrencies = React.useMemo(
    () => [
      {
        attributes: {
          name: "UK Pounds",
          description: "UK British Pounds Sterling",
          codeISO: "GBP",
          symbol: "£",
          rateToBase: 1,
          decimals: 2,
          allowPayments: true,
        },
      },
    ],
    []
  );

  const storedPaymentCurrencies =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("paymentCurrencies"))
      : null;

  const [paymentCurrencies, dispatchPaymentCurrencies] = useReducer(
    paymentCurrenciesReducer,
    storedPaymentCurrencies || defaultPaymentCurrencies
  );

  // Query (via Apollo) for payment currency info
  const { loading, error, data } = useQuery(GET_PAYMENT_CURRENCIES, {
    fetchPolicy: "network-only", // Always fetch from the network
  });

  // Update payment currencies when data is fetched
  useEffect(() => {
    if (loading) {
      console.log("Fetching payment currencies...");
    } else if (error) {
      console.error("Error fetching payment currencies:", error);
      if (!storedPaymentCurrencies) {
        dispatchPaymentCurrencies(
          setPaymentCurrencies(defaultPaymentCurrencies)
        );
      }
    } else if (data) {
      const queryResult = data.currencies.data;
      dispatchPaymentCurrencies(setPaymentCurrencies(queryResult));
      localStorage.setItem("paymentCurrencies", JSON.stringify(queryResult));
      console.log("Payment currencies updated.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data]);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = React.useMemo(
    () => ({ paymentCurrencies, dispatchPaymentCurrencies }),
    [paymentCurrencies]
  );

  return (
    <PaymentCurrenciesProvider value={contextValue}>
      {children}
    </PaymentCurrenciesProvider>
  );
}
